import React from "react";
import { Button } from "@tvg/design-system";
import ActiveBetsButton from "../../ActiveBetsButton";
import { Container } from "./styled-components";
import { RaceWagerSummary } from "../../../../types";

interface AuxiliaryModulesButtonsProps {
  hasWagers?: boolean;
  raceWagersSummary: RaceWagerSummary;
  onClickPoolsInfo: () => void;
  onClickBetsButton?: () => void;
}

const AuxiliaryModulesButtons = ({
  hasWagers,
  raceWagersSummary,
  onClickPoolsInfo,
  onClickBetsButton
}: AuxiliaryModulesButtonsProps) => (
  <Container data-qa-label="auxiliary-buttons-container">
    <Button
      qaLabel="pools-and-info-button"
      variant="tertiary"
      onPress={onClickPoolsInfo}
      icon="info"
      iconPosition="start"
      size="m"
    >
      Pools & info
    </Button>
    {hasWagers && onClickBetsButton && (
      <ActiveBetsButton
        iconPosition="start"
        totalGambledCount={raceWagersSummary.totalGambledCount}
        onClick={onClickBetsButton}
      />
    )}
  </Container>
);

export default AuxiliaryModulesButtons;
